export enum ADDRESS_LEVEL {
  sidoName = 'sidoName',
  guName = 'guName',
  hdongName = 'hdongName',
}

export const CONST_ADDRESS_LEVEL = Object.values(ADDRESS_LEVEL);
